import { render, staticRenderFns } from "./Dialer.vue?vue&type=template&id=ca1a248a&scoped=true"
import script from "./Dialer.vue?vue&type=script&lang=js"
export * from "./Dialer.vue?vue&type=script&lang=js"
import style0 from "./Dialer.vue?vue&type=style&index=0&id=ca1a248a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1a248a",
  null
  
)

export default component.exports